import React from 'react';
import { EditButton } from 'react-admin';
import { ActionsContainer } from '../../../components';

const ShowActions = (props) => {
  return (
    <ActionsContainer {...props}>
      <EditButton />
    </ActionsContainer>
  );
};

export default ShowActions;
